<template>
  <div
    class="avatar__wrp"
    @click="avatarClicked"
    :class="{ make__upload: makeUpload }"
    :style="avatarStyle"
  >
    <img
      v-if="!avatar && makeUpload"
      class="plus__icon"
      src="/dist/assets/front_white/img/plus__icon.svg"
      alt
    />
    <img
      v-if="avatar && !isEmoji"
      class="ava__image"
      :src="srcImageSrc"
      :style="avatarStyle"
      alt
    />
    <img
      v-if="avatar && isEmoji"
      class="ava__emodzi"
      :src="activeAvatarSrc"
      alt
    />
  </div>
</template>

<script>
import Avatars from './avatars.enum.js'

export default {
  name: 'Avatar',
  props: {
    avatar: {
      type: String
    },
    makeUpload: { // стрелять поумолчанию
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 70
    }
  },
  computed: {
    isEmoji () {
      return this.avatar.includes('Avatar')
    },
    activeAvatarSrc () {
      const avatar = Avatars.icon(Avatars[this.avatar.split('/').pop()])
      return `/dist/assets/front_white/img/avatar/${avatar}`
    },
    srcImageSrc () {
      return `/uploads/images/${this.avatar}`
    },
    avatarStyle () {
      return `width: ${this.width}px; height: ${this.width}px`
    }
  },
  methods: {
    avatarClicked () {
      if (this.makeUpload) {
        this.$emit('uploadClicked')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar__wrp {
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #f6f6f6;
	position: relative;
	transition: transform 0.2s;

	.plus__icon {
		display: block;
		max-width: 16px;
		max-height: 16px;
		top: 50%;
		left: 50%;
	}

	.ava__image {
		display: block;
		border-radius: 50%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		object-fit: cover;
	}

	&.make__upload {
		&:hover {
			transform: scale(1.2);
			cursor: pointer;
			background-color: #eaeaea;
		}
	}
}

.ava__emodzi {
	max-width: 70%;
}
</style>
